import { useState, useEffect } from 'react';

const useLaunchTabs = (gamesList) => {
    const [tabValue, setTabValue] = useState(0);
    const [mobileOnly, setMobileOnly] = useState(false);
    const [filteredGamesList, setFilteredGamesList] = useState([]);

    const filterGames = (games) => {
        if (!games || games.length === 0) return [];

        let filtered = games;

        if (mobileOnly !== null) {
            filtered = games.filter((game) => {
                const isDesktopGame = game.launchID?.includes("Desktop");
                return mobileOnly ? !isDesktopGame : isDesktopGame;
            });
        }

        if (tabValue === 1) {
            filtered = filtered.filter((game) => game.GameflexGameID);
        }

        setFilteredGamesList(filtered);
    };

    useEffect(() => {
        filterGames(gamesList);
    }, [gamesList, mobileOnly, tabValue]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        filterGames(gamesList);
    };

    const handleMobileToggle = (newValue, updateServerState) => {
        setMobileOnly(newValue);
        updateServerState((prev) => ({
            ...prev,
            mobDesk: newValue ? "Mobile" : "Desktop",
        }));
        filterGames(gamesList);
    };

    return {
        tabValue,
        mobileOnly,
        filteredGamesList,
        handleTabChange,
        handleMobileToggle
    };
};

export default useLaunchTabs;